import { render, staticRenderFns } from "./LoginLogoC5.15.vue?vue&type=template&id=40b80c7d&"
import script from "./LoginLogoC5.15.vue?vue&type=script&lang=js&"
export * from "./LoginLogoC5.15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports